<template>
  <div>
    <h1
      :style="{
        textAlign: 'center',
        font: 'normal normal 600 36px/55px Poppins',
        letterSpacing: '0',
        color: '#333333',
        textTransform: 'uppercase',
        margin: $vuetify.breakpoint.mdAndUp ? '30px 0' : '20px 0'
      }"
    >
      {{ title }}
    </h1>

    <div
      :style="{
        textAlign: 'center',
        font: 'normal normal normal 18px/35px Lato',
        letterSpacing: '0',
        color: '#777777',
        marginBottom: $vuetify.breakpoint.mdAndUp ? '60px' : '30px',
        padding: $vuetify.breakpoint.mdAndUp ? '0 200px' : '0 15px'
      }"
    >
      {{ subTitle }}
    </div>
  </div>
</template>

<script>
export default {
  name: "AppHeader",

  props: ["title", "subTitle"]
};
</script>
